document.addEventListener('DOMContentLoaded', () => {
  const usageMap = {
    as_needed: {
      bestForLabel: 'Best for',
      bestForValue: 'In the moment',
      durationLabel: 'Supports you',
      durationValue: 'Up to 36 hours',
      instructionsLabel: 'Take',
      instructionsValue: '15 min before sex'
    },
    daily: {
      bestForLabel: 'Best for',
      bestForValue: 'Always ready',
      durationLabel: 'Supports you',
      durationValue: '24/7 support',
      instructionsLabel: 'Take',
      instructionsValue: 'Once daily'
    }
  };

  function parseDrawerData() {
    const dataElement = document.getElementById('brx-session-data');
    if (!dataElement) {
      console.warn('[BRXSelectionDrawer] Missing #brx-session-data element.');
      return null;
    }
    try {
      return JSON.parse(dataElement.textContent);
    } catch (error) {
      console.error('[BRXSelectionDrawer] Failed to parse drawer JSON payload.', error);
      return null;
    }
  }

  function getDrawerElements() {
    return {
      summary: document.querySelector('[data-selection-drawer-summary]'),
      pricing: document.querySelector('[data-selection-drawer-pricing]'),
      details: document.querySelector('[data-selection-drawer-details]')
    };
  }

  function formatMoney(cents) {
    const normalizedCents = Number.isFinite(cents) ? cents : 0;
    return `$${(normalizedCents / 100).toFixed(2)}`;
  }

  function escapeHtml(value) {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getDiscountCents(promos, subtotalCents, promoCode) {
    if (!promoCode) return 0;
    const promo = promos?.[promoCode];
    if (!promo) return 0;
    if (promo.type === 'dollars') return Math.round(promo.value * 100);
    if (promo.type === 'percent') return Math.round(subtotalCents * (promo.value / 100));
    return 0;
  }

  function buildIngredientsHtml(ingredients) {
    if (!ingredients?.length) return '';
    return '<ul class="tw-space-y-3 tw-list-none tw-p-0 tw-m-0">' +
      ingredients.map((ing) => {
        const label = escapeHtml(ing.name) + (ing.strength ? ' ' + ing.strength.value + ing.strength.unit : '');
        return '<li>' +
          '<span class="tw-font-medium tw-text-charcoal">' + label + '</span>' +
          (ing.description ? '<p class="tw-mt-0.5 tw-text-charcoal/70 tw-m-0">' + escapeHtml(ing.description) + '</p>' : '') +
          '</li>';
      }).join('') +
      '</ul>';
  }

  function renderEmptyState(data) {
    const emptyTitle = escapeHtml(data.settings.emptyTitle);
    return `
      <div class="tw-bg-white tw-p-6 tw-text-center">
        <h3 class="tw-font-heading tw-capitalize tw-text-2xl tw-font-bold tw-text-charcoal">
          ${emptyTitle}
        </h3>
      </div>
    `;
  }

  function renderUsageChips(usageType) {
    const usage = usageMap[usageType];
    if (!usage) return '';

    function chip(label, value) {
      return `
        <div class="tw-flex tw-flex-col tw-items-center tw-gap-1 tw-rounded-lg tw-border tw-border-black/10 tw-px-3 tw-py-2 tw-text-center">
          <span class="tw-text-xs tw-leading-none tw-text-charcoal/60 tw-font-medium">${escapeHtml(label)}</span>
          <span class="tw-text-sm tw-font-medium tw-leading-none tw-text-charcoal">${escapeHtml(value)}</span>
        </div>
      `;
    }

    return `
      <div class="tw-grid tw-grid-cols-3 tw-gap-2">
        ${chip(usage.bestForLabel, usage.bestForValue)}
        ${chip(usage.durationLabel, usage.durationValue)}
        ${chip(usage.instructionsLabel, usage.instructionsValue)}
      </div>
    `;
  }

  function renderAccordionItem(title, contentHtml) {
    if (!contentHtml) return '';

    return `
      <div class="tw-border-b tw-border-black/10" data-accordion-item>
        <button
          type="button"
          class="tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-4 tw-py-4 tw-text-left"
          data-accordion-trigger
          aria-expanded="false"
        >
          <span class="tw-text-base tw-font-medium tw-text-charcoal">${escapeHtml(title)}</span>
          <span
            class="material-symbols-outlined tw-text-[20px] tw-text-charcoal tw-transition-transform tw-duration-200"
            data-accordion-icon
            aria-hidden="true"
          >expand_more</span>
        </button>
        <div
          class="tw-grid tw-grid-rows-[0fr] tw-transition-[grid-template-rows] tw-duration-200 tw-ease-out"
          data-accordion-panel
          aria-hidden="true"
        >
          <div class="tw-overflow-hidden">
            <div class="tw-pb-4 tw-text-sm tw-leading-relaxed tw-text-charcoal/80">
              ${contentHtml}
            </div>
          </div>
        </div>
      </div>
    `;
  }

  function initAccordions(container) {
    const accordions = container.querySelectorAll('[data-brx-selection-accordion]');

    accordions.forEach((accordion) => {
      if (accordion.dataset.initialized === 'true') return;
      accordion.dataset.initialized = 'true';

      const items = accordion.querySelectorAll('[data-accordion-item]');

      function closeItem(item) {
        const trigger = item.querySelector('[data-accordion-trigger]');
        const panel = item.querySelector('[data-accordion-panel]');
        const icon = item.querySelector('[data-accordion-icon]');
        if (!trigger || !panel) return;
        trigger.setAttribute('aria-expanded', 'false');
        panel.setAttribute('aria-hidden', 'true');
        panel.classList.remove('tw-grid-rows-[1fr]');
        panel.classList.add('tw-grid-rows-[0fr]');
        icon?.classList.remove('tw-rotate-180');
      }

      function openItem(item) {
        const trigger = item.querySelector('[data-accordion-trigger]');
        const panel = item.querySelector('[data-accordion-panel]');
        const icon = item.querySelector('[data-accordion-icon]');
        if (!trigger || !panel) return;
        trigger.setAttribute('aria-expanded', 'true');
        panel.setAttribute('aria-hidden', 'false');
        panel.classList.remove('tw-grid-rows-[0fr]');
        panel.classList.add('tw-grid-rows-[1fr]');
        icon?.classList.add('tw-rotate-180');
      }

      items.forEach((item) => {
        const trigger = item.querySelector('[data-accordion-trigger]');
        if (!trigger) return;

        trigger.addEventListener('click', () => {
          const isOpen = trigger.getAttribute('aria-expanded') === 'true';
          items.forEach((other) => { if (other !== item) closeItem(other); });
          if (isOpen) closeItem(item); else openItem(item);
        });
      });
    });
  }

  function renderSelectionSummary(data, derived) {
    const product = derived.selectedProduct;
    const productImageUrl = escapeHtml(product?.images?.[0]?.url || data.assets.productFallbackImageUrl || '');
    const productTitle = escapeHtml(product?.title || data.settings.productFallbackTitle);
    const displayTitle = product?.displayTitle || '';
    const supplyDays = derived.supplyDays ?? 30;
    const supplyLabel = supplyDays === 90 ? '90-Day Supply' : '30-Day Supply';

    return `
      <div class="tw-bg-white tw-p-4">
        <div class="tw-flex tw-gap-4">
          <div class="tw-h-[90px] tw-w-[90px] tw-shrink-0 md:tw-h-[110px] md:tw-w-[110px]">
            <img
              src="${productImageUrl}"
              alt="${productTitle}"
              class="tw-h-full tw-w-full tw-rounded-md tw-object-cover"
              loading="eager"
            />
          </div>

          <div class="tw-min-w-0 tw-flex-1">
            <div class="tw-flex tw-items-center tw-justify-between">
                <h3 class="tw-normal-case tw-text-charcoal tw-text-xl tw-text-left">${productTitle}</h3>
                <p class="tw-text-base tw-font-semibold tw-text-charcoal">${formatMoney(derived.activePriceCents)}</p>
            </div>
            ${displayTitle ? `<div class="tw-text-sm tw-text-light-charcoal tw-max-w-[200px]">${displayTitle}</div>` : ''}
            <div class="tw-mt-1 tw-text-xs tw-font-medium tw-text-charcoal/60 tw-uppercase tw-tracking-wider">${supplyLabel}</div>

            <div class="tw-mt-1 tw-flex tw-items-center tw-justify-between">
                <div class="tw-flex tw-items-center tw-gap-1">
                  ${derived.hasOffers ? `
                    <button
                      type="button"
                      class="tw-flex tw-h-6 tw-w-6 tw-items-center tw-justify-center tw-rounded tw-border tw-border-black/20 tw-text-base tw-text-charcoal hover:tw-bg-black/5"
                      data-selection-variant-prev
                      aria-label="Previous offer"
                    ><span class="material-symbols-outlined tw-text-lg">remove</span></button>
                    <span class="tw-text-sm tw-text-charcoal">${escapeHtml(derived.doseLabel)}</span>
                    <button
                      type="button"
                      class="tw-flex tw-h-6 tw-w-6 tw-items-center tw-justify-center tw-rounded tw-border tw-border-black/20 tw-text-base tw-text-charcoal hover:tw-bg-black/5"
                      data-selection-variant-next
                      aria-label="Next offer"
                    ><span class="material-symbols-outlined tw-text-lg">add</span></button>
                  ` : `
                    <button
                      type="button"
                      class="tw-flex tw-h-6 tw-w-6 tw-items-center tw-justify-center tw-rounded tw-border tw-border-black/10 tw-text-base tw-text-charcoal/30 tw-cursor-default"
                      aria-disabled="true"
                      aria-label="Decrease"
                    ><span class="material-symbols-outlined tw-text-lg tw-text-dark-gray">remove</span></button>
                    <span class="tw-text-sm tw-text-charcoal">${escapeHtml(derived.doseLabel)}</span>
                    <button
                      type="button"
                      class="tw-flex tw-h-6 tw-w-6 tw-items-center tw-justify-center tw-rounded tw-border tw-border-black/10 tw-text-base tw-text-charcoal/30 tw-cursor-default"
                      aria-disabled="true"
                      aria-label="Increase"
                    ><span class="material-symbols-outlined tw-text-lg tw-text-dark-gray">add</span></button>
                  `}
                </div>
                <button
                    type="button"
                    class="tw-ml-1 tw-text-sm tw-underline tw-text-charcoal/60 hover:tw-text-charcoal"
                    data-selection-remove
                  ><span class="material-symbols-outlined tw-text-forest-green">delete</span></button>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  function renderPromoBox(data, derived) {
    const promoUi = data.promoUi || {};

    if (derived.isPromoApplied) {
      return `
        <div class="tw-flex tw-items-center tw-justify-between tw-gap-2 tw-text-sm tw-text-charcoal" data-selection-promo-box>
          <span>Code applied: <strong>${escapeHtml(derived.promoCode)}</strong></span>
          <button
            type="button"
            class="tw-text-xs tw-underline tw-text-charcoal hover:tw-text-red-700"
            data-selection-promo-clear
          >Remove</button>
        </div>
      `;
    }

    return `
      <div data-selection-promo-box>
        <div class="tw-flex tw-gap-2">
          <input
            type="text"
            class="tw-flex-1 tw-min-w-0 tw-border tw-border-angel-green tw-rounded tw-px-3 tw-py-2 tw-text-sm tw-text-charcoal tw-bg-white focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-angel-green"
            placeholder="${escapeHtml(promoUi.placeholder || 'Promo code')}"
            data-selection-promo-input
          />
          <button
            type="button"
            class="tw-shrink-0 tw-min-w-[80px] tw-bg-angel-green tw-text-white tw-px-3 tw-py-2 tw-rounded tw-text-sm tw-font-medium tw-transition hover:tw-scale-105"
            data-selection-promo-apply
          >${escapeHtml(promoUi.applyButtonText || 'Apply')}</button>
        </div>
        <p class="tw-mt-1 tw-text-xs tw-text-red-600" data-selection-promo-message hidden></p>
      </div>
    `;
  }

  function renderSelectionPricing(data, derived) {
    const pricing = data.pricing || {};

    const discountRow = derived.isPromoApplied
      ? `
        <div class="tw-flex tw-items-start tw-justify-between tw-gap-4 tw-text-base tw-leading-none tw-border-t tw-border-off-white tw-pt-3">
          <span class="tw-text-sm tw-text-angel-green">${escapeHtml(pricing.discountLabel || 'Discount')}</span>
          <span class="tw-text-sm tw-text-angel-green">-${formatMoney(derived.discountCents)}</span>
        </div>
      `
      : '';

    const savingsRow = derived.savingsText
      ? `<p class="tw-text-sm tw-text-center tw-text-angel-green">${escapeHtml(derived.savingsText)}</p>`
      : '';

    return `
      <div class="tw-px-4 tw-pb-4 tw-pt-2 tw-bg-white">
        <div class="tw-flex tw-flex-col tw-gap-3">
          <div class="tw-flex tw-items-start tw-justify-between tw-gap-4 tw-text-base tw-leading-none tw-border-b tw-border-off-white tw-pb-3">
            <span class="tw-text-sm tw-text-light-charcoal">Shipping</span>
            <span class="tw-text-sm tw-text-light-charcoal">FREE</span>
          </div>
          <div class="tw-flex tw-items-start tw-justify-between tw-gap-4 tw-text-base tw-leading-none tw-border-b tw-border-off-white tw-pb-3">
            <span class="tw-text-sm tw-text-light-charcoal">Patient Portal</span>
            <span class="tw-text-sm tw-text-light-charcoal">FREE</span>
          </div>
          <div class="tw-flex tw-items-start tw-justify-between tw-gap-4 tw-text-base tw-leading-none tw-text-charcoal">
            <span class="tw-text-sm tw-text-light-charcoal">${escapeHtml(pricing.refillsLabel || 'Refills')}</span>
            <span class="tw-text-sm tw-text-light-charcoal">${derived.supplyDays === 90 ? '3' : '11'}</span>
          </div>
          ${discountRow}
          <div class="tw-flex tw-items-start tw-justify-between tw-gap-4 tw-text-base tw-leading-none tw-text-charcoal tw-border-t tw-border-forest-green tw-pt-3">
            <span class="tw-text-base tw-font-medium tw-text-angel-green">${escapeHtml(pricing.grandTotalLabel || 'Total')}</span>
            <span class="tw-text-base tw-font-medium tw-text-angel-green">${formatMoney(derived.grandTotalCents)}</span>
          </div>
          ${savingsRow}
        </div>

        <div class="tw-mt-4">
          ${renderPromoBox(data, derived)}
        </div>

        <div class="tw-mt-4 tw-w-full tw-max-w-[400px] tw-mx-auto">
            <a
              href="${escapeHtml(derived.checkoutUrl)}"
              class="tw-block tw-text-white tw-bg-angel-green tw-w-full tw-p-4 tw-rounded-lg tw-font-medium tw-uppercase tw-text-center tw-transition hover:tw-scale-105 hover:tw-text-white"
              data-selection-drawer-checkout
            >
              Checkout
            </a>
        </div>
        <div class="tw-mt-3 tw-flex tw-items-center tw-justify-center tw-gap-2 tw-text-sm tw-text-charcoal">
            <img src="//braverx.com/cdn/shop/files/fi_10352713_3.svg?v=1768314537&amp;width=50" alt="" class="tw-h-5 tw-w-5 tw-object-contain" loading="lazy">
            <span>Free Discreet Shipping</span>
        </div>
      </div>
    `;
  }

  function renderSelectionDetails(derived) {
    const product = derived.selectedProduct;
    const usageType = product?.usageType || '';
    const activeIngredientsHtml = buildIngredientsHtml(product?.ingredients || []);
    const sections = product?.contentSections || [];
    function getSection(key) {
      for (const s of sections) { if (s.key === key) return s.content || ''; }
      return '';
    }
    const descriptionHtml = getSection('description');
    const whatToKnowHtml = getSection('what_to_know');
    const howToTakeHtml = getSection('how_to_take');
    const hasAccordion = activeIngredientsHtml || whatToKnowHtml || howToTakeHtml;

    return `
      <div class="tw-bg-white tw-pt-4">
        ${renderUsageChips(usageType)}
        <div class="tw-mt-4 tw-text-sm tw-leading-relaxed tw-text-charcoal/80">${descriptionHtml}</div>
        ${hasAccordion
          ? `
            <div class="tw-mt-4 tw-border-t tw-border-black/10" data-brx-selection-accordion>
              ${renderAccordionItem('Active Ingredients', activeIngredientsHtml)}
              ${renderAccordionItem('What to Know', whatToKnowHtml)}
              ${renderAccordionItem('How to Take', howToTakeHtml)}
            </div>
          `
          : ''}
      </div>
    `;
  }

  function render({ data, derived, isEmpty, elements }) {
    if (!elements.summary) return;

    if (isEmpty) {
      elements.summary.innerHTML = renderEmptyState(data);
      elements.pricing.innerHTML = '';
      elements.details.innerHTML = '';
      return;
    }

    elements.summary.innerHTML = renderSelectionSummary(data, derived);
    elements.pricing.innerHTML = renderSelectionPricing(data, derived);
    elements.details.innerHTML = renderSelectionDetails(derived);

    initAccordions(elements.details);
  }

  function renderFromSession() {
    const sessionState = window.BRXSession.getState();
    const product = window.BRXSession.getSelectionProduct();
    const cadence = window.BRXSession.getSelectionVariant();
    const promos = window.BRXSession.getPromos();
    const isEmpty = !sessionState.initialized || !sessionState.selection.productHandle;

    const promoCode = sessionState.promoCode || null;
    const activePriceCents = cadence?.priceCents ?? 0;
    const supplyDays = cadence?.supplyDays ?? 30;

    const offers = product?.offers || [];
    let selectedOffer = null;
    for (const offer of offers) {
      if (offer.cadences?.some(c => String(c.id) === String(cadence?.id))) {
        selectedOffer = offer;
        break;
      }
    }

    const cadenceMultiplier = supplyDays === 90 ? 3 : 1;
    const baseDoseCount     = selectedOffer ? (selectedOffer.doseCount || 30) : 30;
    const doseLabel         = (baseDoseCount * cadenceMultiplier) + ' Count';

    const discountCents = getDiscountCents(promos, activePriceCents, promoCode);
    const grandTotalCents = Math.max(0, activePriceCents - discountCents);
    const isPromoApplied = discountCents > 0;
    const savingsText = isPromoApplied
      ? (data.pricing?.savingsTemplate || '')
          .replace('{amount}', formatMoney(discountCents))
          .replace('{code}', promoCode)
      : '';
    const resolvedCheckout = window.BRXSession.getResolvedCheckoutUrl();
    const checkoutUrl = resolvedCheckout?.url || data.settings?.intakeBaseUrl || '';

    const derived = {
      selectedProduct: product,
      selectedCadence: cadence,
      selectedOffer,
      hasOffers: offers.length > 1,
      supplyDays,
      activePriceCents,
      promoCode,
      discountCents,
      grandTotalCents,
      isPromoApplied,
      savingsText,
      checkoutUrl,
      doseLabel
    };

    render({ data, derived, isEmpty, elements });
  }

  function cycleVariant(direction) {
    const product = window.BRXSession.getSelectionProduct();
    const cadence = window.BRXSession.getSelectionVariant();
    const offers = product?.offers || [];
    if (offers.length <= 1) return;

    let currentOfferIndex = 0;
    for (let i = 0; i < offers.length; i++) {
      if (offers[i].cadences?.some(c => String(c.id) === String(cadence?.id))) {
        currentOfferIndex = i;
        break;
      }
    }

    const nextIndex = (currentOfferIndex + direction + offers.length) % offers.length;
    const nextOffer = offers[nextIndex];
    const targetSupplyDays = cadence?.supplyDays ?? 90;
    const nextCadence = nextOffer.cadences?.find(c => c.supplyDays === targetSupplyDays)
                     || nextOffer.cadences?.[0];
    if (!nextCadence) return;

    const sel = window.BRXSession.getState().selection;
    window.BRXSession.setSelection({
      groupKey: sel.groupKey,
      productHandle: product.handle,
      variantId: nextCadence.id,
      medId: nextCadence.medId || null
    });
  }

  function bindEvents(data) {
    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-selection-variant-prev]')) {
        event.preventDefault();
        cycleVariant(-1);
        return;
      }

      if (event.target.closest('[data-selection-variant-next]')) {
        event.preventDefault();
        cycleVariant(1);
        return;
      }

      if (event.target.closest('[data-selection-remove]')) {
        event.preventDefault();
        window.BRXSession.clearSelection();
        return;
      }

      if (event.target.closest('[data-selection-promo-apply]')) {
        const input = document.querySelector('[data-selection-promo-input]');
        const code = String(input?.value || '').trim().toUpperCase();
        if (!code) return;
        window.BRXSession.setPromoCode(code);
        if (window.BRXSession.getPromoCode() !== code) {
          const msg = document.querySelector('[data-selection-promo-message]');
          if (msg) {
            msg.textContent = data.promoUi?.invalidMessage || 'Invalid code';
            msg.hidden = false;
          }
        }
        return;
      }

      if (event.target.closest('[data-selection-promo-clear]')) {
        window.BRXSession.clearPromoCode();
      }
    });
  }

  function focusPanel() {
    const panel = document.querySelector('[data-brx-panel]');
    if (panel) panel.focus();
  }

  const data = parseDrawerData();
  const elements = getDrawerElements();

  if (!data || !elements.summary) return;

  function initDrawer() {
    if (!window.BRXSession) return;
    window.BRXSession.subscribe(renderFromSession);
    bindEvents(data);
    window.BRXSelectionDrawer = {
      renderFromSession,
      focusPanel,
      reset: () => window.BRXSession.clearSelection(),
      cycleVariant
    };
  }

  if (window.BRXSession) {
    initDrawer();
  } else {
    window.addEventListener('brx:session-ready', initDrawer, { once: true });
  }
});
